import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/index';
import { encryptTransform } from 'redux-persist-transform-encrypt'; // Ensure this is correctly imported
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session'; 
import authMiddleware from './middleware/authMiddleware'; // Ensure this import is correct

const PERSIST_KEY = process.env.REACT_APP_PERSIST_KEY;

// Encryption configuration
const encryptionConfig = {
  secretKey: PERSIST_KEY,
  onError: function(error) {
    console.error('Encryption error:', error);
  }
};

const encryptedTransform = encryptTransform(encryptionConfig);

const persistConfig = {
  key: 'root',
  storage: storage,
  transforms: [encryptedTransform],
  whitelist: ['residentlog', 'uin', 'otp', 'session', 'verify', 'faceAuth', 'location', 'pdfData'] 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  applyMiddleware(thunk, authMiddleware)
);

const persistor = persistStore(store);

export { store, persistor };
